import { render, staticRenderFns } from "./AzureArchitectureForm.vue?vue&type=template&id=4e29bc0b&scoped=true"
import script from "./AzureArchitectureForm.vue?vue&type=script&lang=js"
export * from "./AzureArchitectureForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29bc0b",
  null
  
)

export default component.exports